import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import {
  fetchProfile,
  patchProfile,
} from '@zr/utilities/api/profile';

import LoadingAnimation from '@zr/components/LoadingAnimation';

import BasicInfoForm from './BasicInfoForm';

import './BasicInfo.less';

export function BasicInfo({
  header,
  ipCountryCode,
  locationAutocompleteUrl,
  onError,
  onSubmit,
  salaryNote,
  submitText,
  setIsLoading,
}) {
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const profile = await fetchProfile();
        const {
          country,
          city,
          state,
          location,
          zip_code: zipcode,
          desired_salary: desiredSalary,
          will_work_remotely: willWorkRemotely,
        } = profile;

        setInitialValues({
          country: country || ipCountryCode,
          city,
          state,
          location,
          zipcode,
          desiredSalary,
          willWorkRemotely,
        });
      } catch (error) {
        onError(error);
      }
    })();
  }, [ipCountryCode, onError]);

  const handleSubmit = async (data) => {
    try {
      // `setIsLoading(true)` so that we can disable the close button while the
      // screen is processing/loading
      setIsLoading(true);
      await patchProfile(data);
      onSubmit();
    } catch (error) {
      onError(error);
    }
  };

  return (
    <>
      {!initialValues ? (
        <div className="BasicInfo">
          <LoadingAnimation />
        </div>
      ) : (
        <section className="BasicInfo">
          {!header && <h1 className="header">{'We\'ve created your profile for you, but need a little more information.'}</h1>}
          <BasicInfoForm
            header={header}
            initialValues={initialValues}
            locationAutocompleteUrl={locationAutocompleteUrl}
            onSubmit={handleSubmit}
            salaryNote={salaryNote}
            submitText={submitText}
          />
        </section>
      )}
    </>
  );
}

BasicInfo.propTypes = {
  header: PropTypes.string,
  ipCountryCode: PropTypes.string,
  locationAutocompleteUrl: PropTypes.string.isRequired,
  onError: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  salaryNote: PropTypes.node,
  setIsLoading: PropTypes.func,
  submitText: PropTypes.string,
};

BasicInfo.defaultProps = {
  header: null,
  ipCountryCode: '',
  onError: () => {},
  // Deliberately undefined so as to not defeat the default in the form
  salaryNote: undefined,
  setIsLoading: () => {},
  submitText: 'Save & Continue',
};

export default BasicInfo;
